import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '../../components/Header'
import Loading from '../../components/Loader'
import Footer from '../../components/footer'
import complianceImg from '../../assets/images/compliance.jpg'
import '../../assets/sass/views/Tutorial.scss'

const Play = () => {
  const { t } = useTranslation('global')
  const [loading, setLoading] = useState({ status: true })
  useEffect(() => {
    setTimeout(() => {
      setLoading({ status: false })
    }, 500)
  }, [])
  return (
    <>
      {loading.status ? <Loading addClass={'active'} /> : ''}
      <Header activeTab={1} />
      <div className='error-sec'>
        <h1>{t('views.play.title')}</h1>
        <p style={{ color: '#fff', maxWidth: '700px', textAlign: 'center', marginBottom: '16px' }}>
          {t('views.play.p1')}
        </p>
        <p style={{ color: '#fff', maxWidth: '700px', textAlign: 'center', marginBottom: '16px' }}>
          {t('views.play.p2')}
        </p>
        <p style={{ color: '#fff', maxWidth: '700px', textAlign: 'center', marginBottom: '32px' }}>
          {t('views.play.p3')}
        </p>
        <a href="mailto:info@noracle.io">
          <img src={complianceImg} alt="Contact Us / Partner with Us" style={{ maxWidth: '320px', borderRadius: '16px', cursor: 'pointer', opacity: 0.9 }} />
        </a>
      </div>
      <Footer isVisibleBall={false} />
    </>
  )
}

export default Play
